import React from "react";
import { LinkSimpleIcon } from "@phosphor-icons/react";

import { CompanyInfoStyles } from "pages/RosterStatusPage/styled";

import Icon from "components/Icon/Icon";
import Input from "components/Input/index";
import Select from "components/Select/index";

const ContactSocial = ({
  formData,
  setFormData,
  handleInputChange,
  handleSelectChange,
  dropdownOptions
}) => {
  return (
    <CompanyInfoStyles>
      {/* --- Row 1 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Input
            id="company_email"
            label="Company Email"
            placeholder="Enter Company Email"
            value={formData?.email ?? ""}
            onChange={handleInputChange("email")}
            size="M"
          />
        </div>
        <div className="text-area-wrapper">
          <Input
            id="company_phone"
            codeId="company_id"
            type="tel"
            label="Company Phone"
            countryCodePlaceholder="+91"
            placeholder="Enter Phone Number"
            value={formData?.phone_number ?? ""}
            onChange={handleInputChange("phone_number")}
            country_code_value={formData?.country_code}
            onCountryCodeChange={handleInputChange("country_code")}
            size="M"
          />
        </div>
      </div>

      {/* --- Row 2 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Select
            id="city"
            label="City"
            value={formData?.city_id ?? ""}
            onChange={handleSelectChange("city")}
            placeholder="Select City"
            options={dropdownOptions.cities}
          />
        </div>
        <div className="text-area-wrapper">
          <Select
            id="industry"
            label="Industry"
            value={formData?.industry_id ?? ""}
            onChange={handleSelectChange("industry")}
            placeholder="Select Industry"
            options={dropdownOptions.industries}
          />
        </div>
      </div>

      {/* --- Row 3 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Input
            id="instagram"
            label="Instagram"
            placeholder="Enter Instagram Link"
            value={formData?.instagram ?? ""}
            onChange={handleInputChange("instagram")}
            leftIcon={
              <Icon
                component={LinkSimpleIcon}
                format="outline"
                weight="regular"
                color="#A5A5A5"
              />
            }
            size="M"
          />
        </div>
        <div className="text-area-wrapper">
          <Input
            id="linkedin"
            label="LinkedIn"
            placeholder="Enter LinkedIn Link"
            value={formData?.linkedin ?? ""}
            onChange={handleInputChange("linkedin")}
            leftIcon={
              <Icon
                component={LinkSimpleIcon}
                format="outline"
                weight="regular"
                color="#A5A5A5"
              />
            }
            size="M"
          />
        </div>
      </div>

      {/* --- Row 4 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Input
            id="facebook"
            label="Facebook"
            placeholder="Enter Facebook Link"
            value={formData?.facebook ?? ""}
            onChange={handleInputChange("facebook")}
            leftIcon={
              <Icon
                component={LinkSimpleIcon}
                format="outline"
                weight="regular"
                color="#A5A5A5"
              />
            }
            size="M"
          />
        </div>

        <div className="text-area-wrapper">
          <Select
            id="status"
            label="Company Status"
            value={formData?.status ?? ""}
            onChange={handleSelectChange("status")}
            placeholder="Select Status"
            options={dropdownOptions.statuses}
          />
        </div>
      </div>

      {/* --- Row 5 --- */}
      <div className="company-form-wrapper">
        <div className="input-wrappers">
          <Select
            id="specialized-in"
            label="Specialized In"
            value={formData?.specialized_in ?? ""}
            onChange={handleSelectChange("specialized_in")}
            placeholder="Select Region"
            options={dropdownOptions.specializedIn}
            size="M"
            isMulti={false}
          />
        </div>
      </div>

      {/* --- Checkbox --- */}
      <div className="company-form-wrapper">
        <label className="lead-email-title">
          <input
            type="checkbox"
            checked={formData?.exclude_weekly_ta_mails ?? ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                exclude_weekly_ta_mails: e.target.checked
              }))
            }
          />
          Exclude Weekly TA Lead Emails
        </label>
      </div>
    </CompanyInfoStyles>
  );
};

export default ContactSocial;
